export default __webpack_public_path__ + "static/pragicts-secops-services-cloud-security-359761e4c96bf2271ff7a873af2ddaa7.jpg";